// Aquí está el slice de confirmación de usuario
import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  confirming: false,
  confirmed: false,
  sendCode: false,
  error: null,
};

const confirmSlice = createSlice({
  name: "confirm",
  initialState,
  reducers: {
    startConfirmation: (state) => {
      state.confirming = true;
      state.error = null;
    },
    confirmSuccess: (state) => {
      state.confirming = false;
      state.confirmed = true;
    },
    confirmFailure: (state, action) => {
      state.confirming = false;
      state.error = action.payload;
    },
    resendCodeSuccess: (state) => {
      state.sendCode = true;
    },
    resendCodeFailure: (state, action) => {
      state.sendCode = false;
      state.error = action.payload;
    },
    resetConfirmation: (state) => {
      state.confirming = false;
      state.confirmed = false;
      state.error = null;
      state.sendCode = false;
    },
  },
});

export const {
  startConfirmation,
  confirmSuccess,
  confirmFailure,
  resendCodeSuccess,
  resendCodeFailure,
  resetConfirmation,
} = confirmSlice.actions;

export default confirmSlice.reducer;
